export const isMobile = () => {
  return (
    /Android/i.test(navigator.userAgent) ||
    /iPhone|iPad/i.test(navigator.userAgent)
  );
};
